export default __webpack_public_path__ + "static/media/KitchenAid.d087dfe3.svg";